import { Component } from "@angular/core";
import { AuthService } from '../../_services/auth.service';

@Component({
    selector: "pagenotfound",
    templateUrl: "./pagenotfound.component.html",
    styleUrls: ['./pagenotfound.component.css']
})

export class PageNotFoundComponent {

    constructor(private authService: AuthService) { }

}


// WEBPACK FOOTER //
// ./ClientApp/app/components/pagenotfound/pagenotfound.component.ts